module.exports = __webpack_public_path__ + "d958ddc12fc90eeee4b9546f4670c80b.png";